import React, { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

import BackToTop from "../../components/BackToTop";
import Contact from "../../components/Contact";
import Footer from "../../Layout/Footer";
import FooterAlt from "../../Layout/FooterAlt";
import NavBar from "../../Layout/Navbar";
import { getProductBySlug } from "../../data/products";

const ProductList = ({ points }) => (
  <ul>
    {points.map((point) => (
      <li key={point}>
        <i className="mdi mdi-check-circle-outline"></i>
        <span>{point}</span>
      </li>
    ))}
  </ul>
);

const ProductDetail = () => {
  const { productSlug } = useParams();
  const product = getProductBySlug(productSlug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [productSlug]);

  if (!product) {
    return <Navigate to="/#products" replace />;
  }

  return (
    <React.Fragment>
      <NavBar isDark={true} />
      <main className="product-detail-page">
        <section className="section product-hero">
          <img className="product-hero-art" src={product.image} alt="" />
          <Container>
            <Row>
              <Col lg={8}>
                <Link to="/#products" className="product-back-link">
                  Products
                </Link>
                <h1>{product.title}</h1>
                <h2>{product.subtitle}</h2>
                <p className="product-hero-description">
                  {product.description}
                </p>
                <p className="product-hero-summary">{product.summary}</p>
                <p className="product-promise">{product.promise}</p>
                <div className="product-hero-actions">
                  <a href="#product-contact" className="btn btn-primary">
                    Request Demo
                  </a>
                  <a href="#product-contact" className="btn btn-outline-dark">
                    Book Consultation
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="section product-approval-section">
          <Container>
            <Row className="justify-content-center">
              <Col lg={9}>
                <div className="product-section-heading text-center">
                  <p className="text-uppercase text-muted mb-2">
                    Approval First
                  </p>
                  <h2>Trusted Access Starts With Approval</h2>
                  <div className="title-border mt-3"></div>
                </div>
                <div className="product-approval-copy">
                  {product.approvalIntro.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="section bg-light product-pillar-section">
          <Container>
            <div className="product-section-heading text-center">
              <p className="text-uppercase text-muted mb-2">Why Citra Access</p>
              <h2>Secure. Scalable. Auditable.</h2>
              <div className="title-border mt-3"></div>
            </div>
            <Row className="g-4 mt-4">
              {product.pillars.map((pillar) => (
                <Col lg={4} md={6} key={pillar.title}>
                  <div className="product-pillar-card">
                    <h3>{pillar.title}</h3>
                    <p>{pillar.description}</p>
                    <ProductList points={pillar.points} />
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="section product-flow-section">
          <Container>
            <div className="product-section-heading text-center">
              <p className="text-uppercase text-muted mb-2">How It Works</p>
              <h2>Approval-Driven User Provisioning</h2>
              <div className="title-border mt-3"></div>
            </div>
            <div className="product-flow">
              {product.steps.map((step, index) => (
                <div className="product-flow-step" key={step.title}>
                  <span>{index + 1}</span>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              ))}
            </div>
          </Container>
        </section>

        <section className="section bg-light product-sap-section">
          <Container>
            <div className="product-section-heading text-center">
              <p className="text-uppercase text-muted mb-2">Built For SAP</p>
              <h2>Designed Across The SAP Landscape</h2>
              <div className="title-border mt-3"></div>
            </div>
            <Row className="g-4 mt-4">
              {product.sapFit.map((group) => (
                <Col lg={3} md={6} key={group.title}>
                  <div className="product-sap-card">
                    <h3>{group.title}</h3>
                    <ProductList points={group.points} />
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="section product-comparison-section">
          <Container>
            <div className="product-section-heading text-center">
              <p className="text-uppercase text-muted mb-2">Comparison</p>
              <h2>Citra Access vs Traditional Self-Registration</h2>
              <div className="title-border mt-3"></div>
            </div>
            <div className="product-comparison-table">
              <table>
                <thead>
                  <tr>
                    <th>Capability</th>
                    <th>Standard Self Registration</th>
                    <th>Citra Access</th>
                  </tr>
                </thead>
                <tbody>
                  {product.comparison.map((row) => (
                    <tr key={row.capability}>
                      <td>{row.capability}</td>
                      <td>{row.standard}</td>
                      <td>{row.citraAccess}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Container>
        </section>

        <Contact
          id="product-contact"
          eyebrow="Citra Access"
          title={product.contact.title}
          description={product.contact.description}
          enquiry={product.contact.enquiry}
          messagePlaceholder={product.contact.messagePlaceholder}
          submitLabel={product.contact.submitLabel}
          showContactCards={false}
        />
      </main>
      <Footer />
      <FooterAlt />
      <BackToTop />
    </React.Fragment>
  );
};

export default ProductDetail;
